/* unplugin-vue-components disabled */import script from "./SettlementTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./SettlementTable.vue?vue&type=script&setup=true&lang=ts"

import "./SettlementTable.vue?vue&type=style&index=0&id=2cc03a42&lang=less&scoped=true"

import exportComponent from "/data/jenkins/workspace/infra_PayAdminWeb/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2cc03a42"]])

export default __exports__